"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DtoBase = void 0;
var ClassTransformer = __importStar(require("class-transformer"));
var convertObjectPropertyToGetterAndSetterName_1 = require("../utils/convertObjectPropertyToGetterAndSetterName");
var encodeObjectToQueryParam_1 = require("../utils/encodeObjectToQueryParam");
var DtoBase = /** @class */ (function () {
    function DtoBase(options) {
        var _this = this;
        this.options = options;
        // adding all dynamic getters and setters here
        // to allow typescript to 'see' and infer them properly
        this.source = {};
        this.reflectionDefinePropertyConfig = {
            configurable: true,
            writable: true,
            enumerable: true,
        };
        this.generateGettersAndSetters = function () {
            Object.keys(_this.model).forEach(function (propertyKey) {
                var _a = (0, convertObjectPropertyToGetterAndSetterName_1.convertObjectPropertyToGetterAndSetterName)(propertyKey), getterMethodName = _a.getterMethodName, setterMethodName = _a.setterMethodName;
                Reflect.defineProperty(_this.source, getterMethodName, __assign(__assign({}, _this.reflectionDefinePropertyConfig), { value: function () {
                        return _this.model[propertyKey];
                    } }));
                Reflect.defineProperty(_this.source, setterMethodName, __assign(__assign({}, _this.reflectionDefinePropertyConfig), { value: function (value) {
                        _this.model[propertyKey] = value;
                    } }));
            });
        };
        var model = options.model;
        this.model = model;
        this.generateGettersAndSetters();
    }
    DtoBase.prototype.toJSON = function (transformOptions) {
        return ClassTransformer.instanceToPlain(this.model, transformOptions);
    };
    DtoBase.prototype.toSerializedModel = function (transformOptions) {
        return ClassTransformer.instanceToInstance(this.model, transformOptions);
    };
    DtoBase.prototype.serializedModelToUrlQueryParams = function () {
        return (0, encodeObjectToQueryParam_1.encodeObjectToQueryParam)({
            payload: this.toSerializedModel(),
        });
    };
    return DtoBase;
}());
exports.DtoBase = DtoBase;
